import module from 'fan/proyecto/module.js'
import template from './template.html'

const diacriticosRegex = /[,.\u0300-\u036f]/g
const diacriticosEspacios = /\s+\s/g
const normalizar = (valor) => valor.normalize('NFD').replace(diacriticosRegex, '').replace(diacriticosEspacios, ' ').toUpperCase().trim()

function Modelo () {
  this.colaborador_id = null
  this.departamento_id = null
  this.departamento = null
  this.colaborador = ''
  this.completado = false
  this.actualizado = false
  this.error = null
}

export class FanProyectoColaboradoresEditarDepartamentoComponent {
  constructor ($state, FanProyectoColaboradoresDepartamentosService) {
    this.FanProyectoColaboradoresDepartamentosService = FanProyectoColaboradoresDepartamentosService
    this.$state = $state
    this.data = null
    this.idProyecto = undefined
    this.error = null
    this.resultados = undefined
    this.completado = false
    this.step = 1
    this.alertas = []
    this.departamentos = []
    this.modelo = Modelo
  }

  $onInit () {
    this.promise = this.FanProyectoColaboradoresDepartamentosService.get(this.idProyecto)
      .then((response) => {
        this.departamentos = response.data.map((item) => ({id: item.id, descripcion: normalizar(item.descripcion)}))
      })
    this.headers = [{
      id: 'colaborador_id',
      name: 'ID Colaborador',
      group: 'OPCIONAL',
      parser: (value) => value.trim(),
      processor: (object, value) => {
        object.colaborador_id = value

        return object
      },
      match: (value) => ['ID_COLABORADOR', 'COLABORADOR_ID', 'ID'].indexOf(value.toUpperCase()) >= 0,
    }, {
      id: 'colaborador',
      name: 'Colaborador',
      group: 'OPCIONAL',
      parser: (value) => value.trim(),
      processor: (object, value) => {
        object.colaborador = value

        return object
      },
      match: (value) => ['COLABORADOR', 'EMPLEADO', 'NOMBRE'].indexOf(value.toUpperCase()) >= 0,
    }, {
      id: 'departamento',
      name: 'Departamento',
      group: 'REQUERIDO',
      parser: (value) => value.trim(),
      processor: (object, value) => {
        object.departamento = value

        return object
      },
      match: (value) => value.toUpperCase() === 'DEPARTAMENTO',
    }]
  }

  vincular (coincidencias) {
    if (!coincidencias) return

    this.resultados = this.data.map((item) => {
        let coincidencia = coincidencias.find((coincidencia) => coincidencia.id === item.id)
        if (coincidencia) {
          item.colaborador_descripcion = coincidencia.colaborador_descripcion
          item.colaborador_id = coincidencia.colaborador_id
          return item
        }
      })
      .filter((item) => item)

    this.resultados.forEach((item, indice) => {
      item.indice = indice + 1
    })

    this.step = 3
  }

  iniciar () {
    this.completado = true
  }

  terminar (data) {
    this.completado = false

    if (data && data.length) {
      let error = data.some((item) => item.error)
      if (!error) {
        this.$state.go('proyecto.colaboradores.lista')
      } else {
        this.resultados.map((item) => {
          let obj = data.find((a) => item.indice === a.indice)
          if (obj) {
            item.error = obj.error
            item.actualizado = obj.actualizado
            item.completado = obj.completado
          }
        })
      }
    }
  }

  importar (event) {
    this.alertas = []
    this.data = null
    this.error = null

    if (!event || !event.headers || !event.data) return

    if (event.headers.indexOf('colaborador') < 0 && event.headers.indexOf('colaborador_id') < 0) {
      return this.error = 'Es necesario seleccionar una columna como "Colaborador" o "Colaborador ID".'
    }

    if (event.headers.indexOf('departamento') < 0) {
      return this.error = 'Es necesario seleccionar una columna como "Departamento".'
    }

    this.data = event.data.filter((item, index) => {
      item.id = index + 1

      if (!item.colaborador_id && !item.colaborador) {
        this.alertas.push(`Se omitirá la fila #${item.id} pues no se especificó el nombre o ID del colaborador.`)
        return false
      }

      let colaboradorDepartamento = normalizar(item.departamento)
      let departamento = this.departamentos.find((departamento) => departamento.descripcion === colaboradorDepartamento) || null

      if (departamento) {
        item.departamento_id = departamento.id
      } else {
        this.alertas.push(`Se omitirá la fila #${item.id} pues no se encontro el departamento especificado`)
        return false
      }
      return true
    })
  }

  validar () {
    this.alertas = []
    if (this.step === 2) return

    this.step = 2
  }
}

module.component('fanProyectoColaboradoresEditarDepartamento', {
  controller: FanProyectoColaboradoresEditarDepartamentoComponent,
  template,
  bindings: {
    idProyecto: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/editar/departamento/component.js